import list_icon from '@/assets/img/device/nd68/icon.png'
import { Mars68 } from './mars68'

export class Mars68Pro extends Mars68 {
  name: string = 'Mars68_PRO'
  icon: string = list_icon
  width: number = 640
}
